import { UI_PRIMITIVE__tooltip } from '../../../components/ui/UI_PRIMITIVE__tooltip';

interface Props {
  children: React.ReactNode;
}

export const ViewTooltipComingSoon: React.FC<Props> = ({ children }) => {
  return (
    <UI_PRIMITIVE__tooltip tooltip_title="Coming soon" delay_duration={0}>
      <div className="opacity-20 cursor-not-allowed">{children}</div>
    </UI_PRIMITIVE__tooltip>
  );
};
